import { useQuery } from '@tanstack/react-query'
import camelcaseKeys from 'camelcase-keys'

import { isActiveExportJobStatus } from '~shared/constants/export-job'
import { ListExportJobsResponseDto } from '~shared/types/export-job.dto'

import { queryKeys } from '~lib/constants/query'
import { ApiService } from '~lib/helpers/api'

export function useExportJobs(campaignId: string) {
  const getExportJobs = async () => {
    const { data } = await ApiService.get<ListExportJobsResponseDto>(
      `/campaigns/${campaignId}/distributions/exports`,
    )
    return camelcaseKeys(data)
  }

  const { data: exportJobs, isLoading: isLoadingExportJobs } = useQuery({
    ...queryKeys.exportJobs.list(campaignId),
    queryFn: getExportJobs,
    refetchInterval: (query) => {
      const jobs = query.state.data
      const hasActiveJob = jobs?.some((job) =>
        isActiveExportJobStatus(job.status),
      )
      return hasActiveJob ? 3000 : false
    },
  })

  const activeJob = exportJobs?.find((job) =>
    isActiveExportJobStatus(job.status),
  )

  const latestJob = exportJobs?.[0]

  return { exportJobs, isLoadingExportJobs, activeJob, latestJob }
}
